import { render, staticRenderFns } from "./dropdown.component.vue?vue&type=template&id=315b2d51&scoped=true&"
import script from "./dropdown.component.vue?vue&type=script&lang=ts&"
export * from "./dropdown.component.vue?vue&type=script&lang=ts&"
import style0 from "./dropdown.component.vue?vue&type=style&index=0&id=315b2d51&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315b2d51",
  null
  
)

export default component.exports